module.exports = __webpack_public_path__ + "img/leftUp.6f588d87.png";